import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import  './NavMenu.css';

const navItems = [
  { to: '/AboutMe', label: 'About me' },
  { to: '/Experience', label: 'Experience' },
  { to: '/Education', label: 'Education' },
  { to: '/Skills', label: 'Skills' },
  { to: '/Projects', label: 'Projects' },
  { to: '/homelab', label: 'Lab Status' },
  { to: '/Blog', label: 'Blog' },
  { to: '/Contact', label: 'Contact' },
];

class NavMenu extends Component {
  render() {
    return (
    <>
    <div className='MyNavBar'>
        <Navbar className="justify-content-center" collapseOnSelect sticky='top' expand='md' bg="dark"  data-bs-theme="dark">
        <Container >
        <Navbar.Brand as={Link} to="/">Elhacen Elmoustapha</Navbar.Brand>

          <Navbar.Toggle aria-controls='responsive-navbar-nav' aria-label='Toggle navigation'/>
         <Navbar.Collapse id='responsive-navbar-nav'>

          <Nav className="m-auto" as="ul">
            {navItems.map((item) => (
              <Nav.Item as="li" key={item.to}>
                <Nav.Link as={NavLink} to={item.to} eventKey={item.to}>
                  {item.label}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      </div>
      </>
    );
  }
}

export default NavMenu;
